import AppInsightsProvider from './AppInsightsProvider';

export default AppInsightsProvider;

export { SeverityLevel } from '@microsoft/applicationinsights-web';
